import { Injectable } from '@angular/core';
import { contractmanagement_api } from '@gridscale/gs-services/contractmanagement_api';
@Injectable({
  providedIn: 'root'
})
export class PriceService {

  /**
   * return if a product is deprecated
   */
  isProductDeprecated(priceObject: contractmanagement_api.PriceDetail) {
    return (priceObject.type?.includes('redis') || priceObject.type?.includes('memcached')) && !!priceObject.type?.match(/gen\s?1/);
  }
}
